import React, { useMemo } from 'react';
import { PowerSettingsNew } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { statusColorObj } from '../../../../themes';
import CustomTooltip from '../../../shared/atoms/CustomTooltip';
import { useLocationsCacheContext } from '../../../../context/LocationsCacheContext';

const SensorCounter = () => {
  const { t } = useTranslation();
  const isDrawerOpen = useSelector(store => store.sideDrawerState.isOpen);
  const { sensors } = useLocationsCacheContext();
  const counter = useMemo(() => {
    let on = 0;
    let off = 0;
    sensors?.forEach(sensor => (sensor.status === 'OFF' ? ++off : ++on));
    return { on, off };
  }, [sensors]);

  return (
    <Stack
      direction={isDrawerOpen ? 'row' : 'column'}
      spacing={1}
      padding={
        isDrawerOpen ? '1rem 1rem 0.5rem 1rem' : '1rem 0.7rem 1rem 0.7rem'
      }
    >
      <Stack
        direction="row"
        justifyContent={isDrawerOpen ? 'flex-start' : 'center'}
      >
        {isDrawerOpen && (
          <Typography>{t('tools_menu.sensor_counter.sensors')}:</Typography>
        )}
      </Stack>
      <CustomTooltip
        title={
          !isDrawerOpen &&
          `${counter.on} ${t('tools_menu.sensor_counter.sensors')} ON`
        }
        placement="right"
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <PowerSettingsNew
            fontSize="small"
            sx={{ color: statusColorObj.normal }}
          />
          <Typography variant="body2">
            {`${isDrawerOpen ? 'ON: ' : ''}${counter.on}`}
          </Typography>
        </Stack>
      </CustomTooltip>
      <CustomTooltip
        title={
          !isDrawerOpen &&
          `${counter.off} ${t('tools_menu.sensor_counter.sensors')} OFF`
        }
        placement="right"
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <PowerSettingsNew
            fontSize="small"
            sx={{ color: statusColorObj.danger }}
          />
          <Typography variant="body2">
            {`${isDrawerOpen ? 'OFF: ' : ''}${counter.off}`}
          </Typography>
        </Stack>
      </CustomTooltip>
    </Stack>
  );
};

export default SensorCounter;
